import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { formatCurrency } from 'utils/formats';
import { TradingOfferPriceContext } from '../../../types/TradingOffer';

type TradingOfferPriceContextCardProps = {
  priceContext: TradingOfferPriceContext;
};

type PriceItem = {
  label: string;
  value: number;
  highlight?: boolean;
};

const TradingOfferPriceContextCard: FC<TradingOfferPriceContextCardProps> = ({
  priceContext,
}) => {
  const { t } = useTranslate();

  const priceItems: PriceItem[] = [
    {
      label: t('LastTransactionPrice'),
      value: priceContext.lastTransactionPrice,
    },
    {
      label: t('AvgSellOffersPrice'),
      value: priceContext.avgSellOffersPrice,
    },
    {
      label: t('OfficialValuation'),
      value: priceContext.officialValuation,
    },
    {
      label: t('YourAvgBuyPrice'),
      value: priceContext.userAvgBuyPrice,
    },
  ];

  const isCompetitivePrice =
    priceContext.currentOfferPrice <= priceContext.avgSellOffersPrice &&
    priceContext.currentOfferPrice > 0;

  return (
    <div className="card card-bordered">
      <div className="card-inner">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h6 className="card-title text-base mb-0">
            <em className="icon ni ni-trend-up text-primary mr-2" />
            {t('PriceContext')}
          </h6>

          {isCompetitivePrice && (
            <span className="badge badge-dim badge-success">
              <em className="icon ni ni-check-circle mr-1" />
              {t('CompetitivePrice')}
            </span>
          )}
        </div>

        <div className="row">
          <div className="col-12 mb-3">
            <div className="alert alert-light py-2 mb-0">
              <div className="d-flex justify-content-between align-items-center">
                <span>{t('CurrentOfferPrice')}</span>
                <strong className="fs-18px">
                  {formatCurrency(priceContext.currentOfferPrice)}/
                  {t('Share').toLowerCase()}
                </strong>
              </div>
            </div>
          </div>

          {priceItems.map((item) => (
            <div className="col-6" key={item.label}>
              <div className="d-flex justify-content-between py-2 border-bottom">
                <span
                  className={`sub-text ${item?.highlight ? 'fw-bold' : ''}`}
                >
                  {item.label}
                </span>
                <span
                  className={`lead-text ${
                    item?.highlight ? 'text-primary fw-bold' : ''
                  }`}
                >
                  {formatCurrency(item.value)}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TradingOfferPriceContextCard;
